import { isDefined } from 'utils/tsHelpers';
import { ListType } from 'modules/domains';
import { PAGE_VARIATIONS } from '../constants';

// Util hook for determining if page is viewing an unsaved segmentation, saved static list, or saved dynamic list
export const useGetPageVariation = (listId?: number, listType?: ListType): PAGE_VARIATIONS => {
  const isStaticList =
    listType === ListType.Standard ||
    listType === ListType.Suppression ||
    listType === ListType.Internal;

  if (isDefined(listId) && listType === ListType.Dynamic) {
    return PAGE_VARIATIONS.DYNAMIC;
  } else if (isDefined(listId) && isStaticList) {
    // Any other list that is not dynamic
    return PAGE_VARIATIONS.STATIC;
  } else {
    return PAGE_VARIATIONS.SEGMENTATION;
  }
};
